import { Skeleton } from 'breeze-intelligence-kit';
import { Section } from 'foundations-components/transitional/components/Section';
import { Tab, Tabs } from 'foundations-components/transitional/components/Tabs';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { useCitation } from '../Citation/useCitation/useCitation';
import { CitationPanelActivity } from './CitationPanelActivity';
import { CitationPanelSources } from './CitationPanelSources';
import { TABS } from './constants';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const CitationPanelContent = ({
  defaultTab
}) => {
  const {
    citation,
    isLoading,
    isError
  } = useCitation();
  if (isLoading) {
    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(Section, {
        children: /*#__PURE__*/_jsx(Skeleton, {
          blockSize: "48px",
          inlineSize: "100%",
          variant: "breeze"
        })
      }), /*#__PURE__*/_jsx(Section, {
        children: /*#__PURE__*/_jsx(Skeleton, {
          blockSize: "100px",
          inlineSize: "100%",
          variant: "breeze"
        })
      }), /*#__PURE__*/_jsx(Section, {
        children: /*#__PURE__*/_jsx(Skeleton, {
          blockSize: "100px",
          inlineSize: "100%",
          variant: "breeze"
        })
      })]
    });
  }
  if (isError || !citation) {
    return /*#__PURE__*/_jsx("div", {
      children: "Error"
    });
  }
  return /*#__PURE__*/_jsxs(Tabs, {
    defaultSelected: defaultTab,
    fill: true,
    panelStyles: {
      paddingInline: '0'
    },
    children: [/*#__PURE__*/_jsx(Tab, {
      tabId: TABS.activity,
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "smartPropertyCitationPanel.tabs.activity"
      }),
      children: /*#__PURE__*/_jsx(CitationPanelActivity, {
        citation: citation
      })
    }), /*#__PURE__*/_jsx(Tab, {
      tabId: TABS.sources,
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "smartPropertyCitationPanel.tabs.sources"
      }),
      children: /*#__PURE__*/_jsx(CitationPanelSources, {
        citation: citation
      })
    })]
  });
};